import { api } from '@xtnd/web/shared/api';

/**
 * Response interface for system template library
 */
export interface TemplateLibraryResponse {
  templates: Array<{
    templateId: string;
    templateName: string;
    templateType: 'pdf' | 'email' | 'document';
    version: string;
    isActive: boolean;
    description?: string;
    tags?: string[] | string;
    variables?: Record<string, any>;
    fileSize: number;
    createdAt: string;
    createdBy: string;
    tenantId?: string;
    hasTemplateContent?: boolean;
    sampleData?: any;
  }>;
}

/**
 * API service for system template library operations
 */
class TemplateLibraryApi {
  /**
   * Fetch system templates from the library
   * @param type - Optional filter by template type (pdf, email, document)
   * @returns Promise with system templates
   */
  async getSystemTemplates(type?: string): Promise<TemplateLibraryResponse> {
    const params = type && type !== 'all' ? `?type=${type}` : '';
    const endpoint = `/templates/library${params}`;
    return api.get<TemplateLibraryResponse>(endpoint);
  }
}

export const templateLibraryApi = new TemplateLibraryApi();

